import { Keuzehulp } from '../keuzehulpen'

const psa: Keuzehulp = {
  title: 'Testen op prostaatkanker',
  basePath: '/psa',
  documentTitle: 'psa',
  routes: [
    {
      path: '',
      routeId: 'P2-001',
      nextRouteId: 'P2-002',
      type: 'intro',
      title: 'Voordat je begint...',
      backButton: 'https://www.thuisarts.nl/keuzehulp/testen-op-prostaatkanker',
      columns: [
        {
          title: 'Neem de tijd',
          description: 'Neem alle tijd die je nodig hebt om de keuzehulp in te vullen. ',
        },
        {
          title: '​​​Tijdsduur: 15-20 minuten ',
          description: 'Zo lang doen de meeste mensen over deze keuzehulp.',
        },
        {
          title: 'Zoek een rustige plek',
          description: 'Zodat je goed je aandacht erbij kunt houden.',
        },
        {
          title: 'Bekijk je antwoorden.',
          description:
            'Je antwoorden worden niet bewaard. De keuzehulp onthoudt niet waar je gebleven bent.',
        },
      ],
    },
    {
      path: '/stap-1',
      routeId: 'P2-002',
      nextRouteId: 'P2-003',
      type: 'chapter',
      title: 'Meer weten over prostaat en prostaatkanker',
      subtitle: 'Stap 1',
      description: 'Je krijgt eerst uitleg over je prostaat en prostaatkanker.',
      image: {
        src: `${process.env.PUBLIC_URL}/img/testen-prostaatkanker-chapter.jpg`,
        alt: '',
      },
      button: 'Ga verder',
    },
    {
      path: '/stap-1/waar-wil-je-meer-over-weten',
      routeId: 'P2-003',
      nextRouteId: 'P2-004',
      type: 'question',
      hideFromOverview: true,
      title: 'Waar wil je meer over weten?',
      questions: [
        {
          type: 'multiple',
          answers: [
            {
              title: 'Wat is je prostaat?',
              showChapter: '1.2',
            },
            {
              title: 'Wat is prostaatkanker?',
              showChapter: '1.3',
            },
            {
              title: 'Waaraan merk je dat je misschien prostaatkanker hebt?',
              showChapter: '1.4',
            },
          ],
        },
      ],
      button: 'Ga verder',
    },
    {
      path: '/stap-1/wat-is-de-prostaat',
      routeId: 'P2-004',
      routeIndex: '1.2',
      nextRouteId: 'P2-005',
      type: 'explanation',
      title: 'Wat is je prostaat?',
      description:
        'Je prostaat maakt het vocht waar je zaadcellen in zwemmen. Als je klaarkomt, komt dit vocht samen met je zaadcellen naar buiten. Dan heet het sperma. Je prostaat zit onder je blaas, rond je plasbuis.',
      align: 'left',
      titleAlign: 'center',
      image: {
        src: 'https://www.thuisarts.nl/sites/default/files/images/Plasklachten_bij_mannen.png',
        alt: 'Afbeelding van de prostaat',
      },
      button: 'Volgende',
    },
    {
      path: '/stap-1/wat-is-prostaatkanker',
      routeId: 'P2-005',
      routeIndex: '1.3',
      nextRouteId: 'P2-006',
      type: 'explanation',
      title: 'Wat is prostaatkanker?',
      titleAlign: 'center',
      align: 'left',
      description: `
        <p>Bij prostaatkanker groeien er kankercellen in je prostaat. Er zijn 2 soorten prostaatkanker:</p>
        <h2 style="font-size: 18px; line-height: 1.6; margin-bottom: 0;">Prostaatkanker die langzaam groeit</h2>
        <ul style="margin-top: 0;">
          <li>Deze soort prostaatkanker komt het meest voor.</li>
          <li>Deze kanker is minder gevaarlijk dan veel andere soorten kanker. De kans is klein dat de kankercellen naar andere plekken in je lichaam gaan (uitzaaiingen).</li>
          <li>Je hebt er bijna nooit klachten door. Een behandeling is vaak niet nodig.</li>
          <li>Mannen met deze kanker worden gemiddeld net zo oud als mannen zonder prostaatkanker. Ze overlijden meestal niet door prostaatkanker, maar door iets anders.</li>
        </ul>
        <h2 style="font-size: 18px; line-height: 1.6; margin-bottom: 0;">Prostaatkanker die snel groeit</h2>
        <ul style="margin-top: 0;">
          <li>Deze soort prostaatkanker komt minder vaak voor.</li>
          <li>Je kunt er wel klachten door krijgen.</li>
          <li>Bijvoorbeeld doordat de kanker naar andere plekken in je lichaam gaat (uitzaaiingen). Vooral als de kanker in je botten zit, kan dat pijn doen.</li>
          <li>Vaak is behandeling nodig.</li>
          <li>Je hebt meer kans dat je overlijdt door deze soort prostaatkanker.</li>
        </ul>
      `,
      button: 'Ga verder',
    },
    {
      path: '/stap-1/waaraan-merk-je-dat-je-misschien-prostaatkanker-hebt',
      routeId: 'P2-006',
      routeIndex: '1.4',
      nextRouteId: 'P2-007',
      type: 'explanation',
      title: 'Waaraan merk je dat je misschien prostaatkanker hebt?',
      titleAlign: 'center',
      align: 'left',
      description: `
        <p>Als je prostaatkanker hebt, merk je meestal niets. Vooral niet als de kanker langzaam groeit. Problemen met plassen komen bijna nooit door prostaatkanker. De kanker zit namelijk bijna nooit in de buurt van je plasbuis, maar aan de buitenkant van je prostaat. Daardoor drukken kankercellen niet tegen je plasbuis.</p>
        <p>Heb je klachten zoals vaak plassen, een zwakke straal of lang nadruppelen? Dan is je kans op prostaatkanker even groot als bij mannen die deze klachten niet hebben.</p>
      `,
      button: 'Ga verder',
    },
    {
      path: '/stap-1/alleen-klachten-bij-prostaatkanker-die-snel-groeit',
      routeId: 'P2-007',
      nextRouteId: 'P2-008',
      type: 'explanation',
      title: 'Alleen soms klachten als de kanker ver gegroeid is',
      titleAlign: 'center',
      align: 'left',
      description: `
        <p style="margin-bottom: 0;">Alleen als de prostaatkanker al ver gegroeid is, kun je daar soms klachten van krijgen. Je hebt dan bijvoorbeeld last van 1 of meer van deze dingen:</p>
        <ul style="margin-top: 0;">
          <li>pijn als de kanker ook in je botten zit</li>
          <li>afvallen zonder dat je probeert af te vallen</li>
          <li>moe zijn</li>
          <li>minder zin in eten hebben</li>
          <li>problemen met plassen als je prostaat erg groot is geworden</li>
        </ul>
      `,
      button: 'Ga verder',
    },
    {
      path: '/stap-1/testen-op-prostaatkanker',
      routeId: 'P2-008',
      nextRouteId: 'P2-009',
      type: 'explanation',
      title: 'Testen op prostaatkanker',
      titleAlign: 'center',
      align: 'left',
      description: `
        <p>Je huisarts doet 2 onderzoeken om te testen of je prostaatkanker hebt:</p>
        <h2 style="font-size: 18px; line-height: 1.6; margin-bottom: 0;">Voelen aan je prostaat</h2>
        <p style="margin-top: 0;">Je huisarts voelt met een vinger aan je prostaat. Dat gaat via je anus (poepgat). Je huisarts onderzoekt of je prostaat normaal voelt. Als dat niet zo is, kan dit komen door prostaatkanker. Je huisarts stuurt je dan meestal door naar een arts in het ziekenhuis die veel weet over prostaatkanker (uroloog).</p>
        <h2 style="font-size: 18px; line-height: 1.6; margin-bottom: 0;">Bloed laten prikken (PSA-test)</h2>
        <p style="margin-top: 0; margin-bottom: 0;">Je bloed wordt getest op een stofje in je bloed dat je prostaat maakt. Dat heet PSA.</p>
        <ul style="margin-top: 0;">
          <li>Is het PSA 3 of hoger? Dan kan dat komen door prostaatkanker. Maar bijvoorbeeld ook doordat je prostaat groter of ontstoken is.</li>
          <li>Is het PSA lager dan 3? Dan is je kans op prostaatkanker klein.</li>
        </ul>
      `,
      button: 'Ga verder',
    },
    {
      path: '/stap-1/na-de-test-op-prostaatkanker',
      routeId: 'P2-009',
      nextRouteId: 'P2-010',
      type: 'explanation',
      title: 'Na de test op prostaatkanker',
      titleAlign: 'center',
      align: 'left',
      description: `
        <p>Je huisarts weet na de test niet of je prostaatkanker hebt. Als de uitslag van 1 van de 2 onderzoeken niet goed is, stuurt je huisarts je naar het ziekenhuis voor meer onderzoeken.</p>
        <h2 style="font-size: 18px; line-height: 1.6; margin-bottom: 0;">Meer onderzoeken</h2>
        <p style="margin-top: 0; margin-bottom: 0;">De arts in het ziekenhuis kan deze onderzoeken doen:</p>
        <ul style="margin-top: 0;">
          <li>vragen of familieleden prostaatkanker hebben of hebben gehad</li>
          <li>voelen aan je prostaat</li>
          <li>een echo van je prostaat</li>
          <li>een MRI-scan van je prostaat</li>
        </ul>
        <p>Soms is er nog extra onderzoek nodig. De arts haalt met een naald een stukje uit je prostaat. Dat wordt onderzocht om te kijken of er kankercellen in zitten.</p>
        <p>Na deze onderzoeken weet de arts of je prostaatkanker hebt. En of er een grote kans is dat de kanker ook naar andere plekken in je lichaam gaat.</p>
        <p>Als je prostaatkanker hebt, is er soms extra onderzoek nodig. Zoals een PET-scan of een CT-scan. Dat is om te kijken of de kanker ook op andere plekken in je lichaam zit.</p>
      `,
      button: 'Ga verder',
    },
    {
      path: '/stap-2',
      routeId: 'P2-010',
      nextRouteId: 'P2-011',
      type: 'chapter',
      title: 'Wat weet je al over testen op prostaatkanker?',
      subtitle: 'Stap 2',
      description: 'Er komen nu 2 vragen.',
      image: {
        src: `${process.env.PUBLIC_URL}/img/testen-prostaatkanker-chapter.jpg`,
        alt: '',
      },
      button: 'Ga verder',
    },
    {
      path: '/stap-2/vraag-1',
      routeId: 'P2-011',
      nextRouteId: 'P2-012',
      type: 'feedbackQuestion',
      subtitle: 'Vraag',
      title: 'Wordt bij mannen die zich laten testen vaker prostaatkanker ontdekt?',
      feedbackAnswers: [
        {
          title: 'Ja',
          feedback: `
            <h2 style="font-size: 18px; line-height: 1.6;">Dat is het goede antwoord.</h2>
            <p>Bij mannen die zich laten testen, wordt vaker prostaatkanker ontdekt dan bij mannen die zich niet laten testen. Maar een behandeling is niet altijd nodig.</p>
          `,
          correctOption: true,
        },
        {
          title: 'Nee',
          feedback: `
            <h2 style="font-size: 18px; line-height: 1.6;">Dat antwoord is niet goed.</h2>
            <p>Bij mannen die zich laten testen, wordt prostaatkanker vaker ontdekt dan bij mannen die zich niet laten testen. Maar een behandeling is niet altijd nodig.</p>
          `,
          correctOption: false,
        },
      ],
      button: 'Ga verder',
    },
    {
      path: '/stap-2/vraag-2',
      routeId: 'P2-012',
      nextRouteId: 'P2-013',
      type: 'feedbackQuestion',
      subtitle: 'Vraag',
      title:
        'Hebben mannen die zich een keer laten testen op prostaatkanker minder kans om dood te gaan aan prostaatkanker?',
      feedbackAnswers: [
        {
          title: 'Ja',
          feedback: `
            <h2 style="font-size: 18px; line-height: 1.6;">Nee, dat is niet zo.</h2>
            <p>De kans om dood te gaan aan prostaatkanker is even hoog. Mannen die zich een keer laten testen, leven gemiddeld even lang als mannen die dat niet hebben gedaan.</p>
          `,
          correctOption: false,
        },
        {
          title: 'Nee',
          feedback: `
            <h2 style="font-size: 18px; line-height: 1.6;">Dat klopt.</h2>
            <p>De kans om dood te gaan aan prostaatkanker is even hoog. Mannen die zich een keer laten testen, leven gemiddeld even lang als mannen die dat niet hebben gedaan.</p>
          `,
          correctOption: true,
        },
      ],
      button: 'Ga verder',
    },
    {
      path: '/stap-2/meestal-niet-langer-leven-wel-weten-dat-je-kanker-hebt',
      routeId: 'P2-013',
      nextRouteId: 'P2-014',
      type: 'explanation',
      title: 'Meestal niet langer leven, wel weten dat je kanker hebt',
      titleAlign: 'center',
      align: 'left',
      description: `
        <p>Bij mannen die zich laten testen bij de huisarts, wordt dus vaker prostaatkanker ontdekt.</p>
        <p>Toch wordt de kans om dood te gaan aan prostaatkanker niet kleiner door deze testen.</p>
        <p>Eerder weten dat je prostaatkanker hebt, wil dus niet altijd zeggen dat je ook langer leeft. Maar je weet wel dat je kanker hebt. Dat kan moeilijk zijn. Bijvoorbeeld omdat je je er onzeker of angstig door kunt voelen.</p>
        <p>Voor de meeste mensen ziet dat er zo uit:</p>
      `,
      image: {
        src: `${process.env.PUBLIC_URL}/img/testen-prostaatkanker-stap2-verloop.jpg`,
        alt: 'Schematisch overzicht waarin het verloop van prostaatkanker zonder PSA-test wordt vergeleken met het verloop met PSA-test.',
      },
      button: 'Ga verder',
    },
    {
      path: '/stap-3',
      routeId: 'P2-014',
      nextRouteId: 'P2-015',
      type: 'chapter',
      title: 'De voordelen en nadelen van testen op prostaatkanker',
      subtitle: 'Stap 3',
      description: `
        <p>Je kunt denken dat het vooral voordelen heeft om je te laten testen op prostaatkanker. Maar er zijn ook nadelen.</p>
        <p>Om een beslissing te nemen over wel of niet testen, is het belangrijk om de voordelen en nadelen te kennen.</p>
      `,
      image: {
        src: `${process.env.PUBLIC_URL}/img/testen-prostaatkanker-chapter.jpg`,
        alt: '',
      },
      button: 'Ga verder',
    },
    {
      path: '/stap-3/voordelen-van-testen-op-prostaatkanker',
      routeId: 'P2-015',
      nextRouteId: 'P2-016',
      type: 'question',
      title: 'Voordelen van testen op prostaatkanker',
      subtitle: 'Vraag',
      description: `
        <p><strong>Klik op de voordelen die voor jou het belangrijkst zijn.</strong></p>
      `,
      descriptionAlign: 'left',
      questions: [
        {
          type: 'multiple',
          answers: [
            { title: 'Als de uitslag van de test goed is, maak je je minder zorgen.' },
            {
              title:
                'Door de test kun je vroeg ontdekken dat je prostaatkanker hebt die snel groeit. Die kans is klein.',
            },
            {
              title:
                'Als je prostaatkanker hebt die snel groeit, kun je misschien een behandeling krijgen die ervoor zorgt dat de kanker weggaat. Of lange tijd niet groeit. En misschien heb je dan ook een kleinere kans om aan prostaatkanker te overlijden.',
            },
            {
              title:
                'De behandeling kan ervoor zorgen dat de prostaatkanker niet op andere plekken in je lichaam komt (uitzaaiingen). Dan krijg je daar ook geen klachten van.',
            },
            {
              title:
                'Zit de prostaatkanker al wel op andere plekken in je lichaam? Dan kun je een behandeling krijgen die ervoor zorgt dat de kanker lange tijd niet groeit.',
            },
          ],
        },
      ],
      showTextArea: true,
      button: 'Ga verder',
    },
    {
      path: '/stap-3/nadelen-van-testen-op-prostaatkanker',
      routeId: 'P2-016',
      nextRouteId: 'P2-017',
      type: 'question',
      title: 'Nadelen van testen op prostaatkanker',
      subtitle: 'Vraag',
      description: `
        <p><strong>Klik op de nadelen die voor jou het belangrijkst zijn.</strong></p>
      `,
      descriptionAlign: 'left',
      questions: [
        {
          type: 'multiple',
          answers: [
            {
              title:
                'Als de uitslag van de test niet goed is, krijg je meer onderzoeken in het ziekenhuis.',
            },
            {
              title:
                'Deze onderzoeken kunnen vervelend zijn. Je krijgt bijvoorbeeld een prik in je prostaat om weefsel te laten onderzoeken.',
            },
            {
              title:
                'Vaak komt uit die onderzoeken dat je toch geen prostaatkanker hebt. Je hebt je dan voor niets ongerust gemaakt.',
            },
            {
              title:
                'Als je wel prostaatkanker hebt, is dat vaak de soort die langzaam groeit. Hier krijg je bijna nooit last van. Maar je weet dan wel dat je kanker hebt. Dit kan je angstig of onzeker maken.',
            },
            {
              title:
                "Als je prostaatkanker hebt die langzaam groeit, kies je misschien voor behandelingen die niet nodig zijn. Bijvoorbeeld omdat je het moeilijk vindt om niets te doen. Maar bij deze soort prostaatkanker is zo'n behandeling vaak niet nodig. Van die behandelingen kun je wel last hebben. Je kunt bijvoorbeeld je plas niet goed ophouden. Of je krijgt of houdt moeilijk een stijve penis. Deze klachten gaan vaak niet meer over.",
            },
          ],
        },
      ],
      showTextArea: true,
      button: 'Ga verder',
    },
    {
      path: '/stap-4',
      routeId: 'P2-017',
      nextRouteId: 'P2-018',
      type: 'chapter',
      title: 'Je keuze maken',
      subtitle: 'Stap 4',
      description:
        'Op de volgende schermen zie je steeds 2 uitspraken. Kies de uitspraak die het beste bij jou past.',
      image: {
        src: `${process.env.PUBLIC_URL}/img/testen-prostaatkanker-chapter.jpg`,
        alt: '',
      },
      button: 'Ga verder',
    },
    {
      path: '/stap-4/vraag-1',
      routeId: 'P2-018',
      nextRouteId: 'P2-019',
      type: 'question',
      subtitle: 'Vraag',
      title:
        'Om te weten of je prostaatkanker hebt, zijn onderzoeken nodig. Soms worden mensen daar onrustig van.',
      questions: [
        {
          type: 'single',
          answers: [
            { title: 'Ik wil daarom liever geen onderzoeken.' },
            { title: 'Ik wil wel onderzoeken om te weten of ik prostaatkanker heb.' },
          ],
        },
      ],
      button: 'Ga verder',
    },
    {
      path: '/stap-4/vraag-2',
      routeId: 'P2-019',
      nextRouteId: 'P2-020',
      type: 'question',
      subtitle: 'Vraag',
      title:
        'Als het PSA te hoog is, kun je prostaatkanker hebben. Maar heel vaak is dat niet zo. Om het zeker te weten zijn extra onderzoeken in het ziekenhuis nodig. Die kunnen vervelend zijn.',
      questions: [
        {
          type: 'single',
          answers: [
            { title: 'Ik wil deze onderzoeken toch.' },
            { title: 'Ik wil deze onderzoeken niet.' },
          ],
        },
      ],
      button: 'Ga verder',
    },
    {
      path: '/stap-4/vraag-3',
      routeId: 'P2-020',
      nextRouteId: 'P2-021',
      type: 'question',
      subtitle: 'Vraag',
      title: 'Als bij een test prostaatkanker ontdekt wordt, is niet altijd behandeling nodig.',
      questions: [
        {
          type: 'single',
          answers: [
            { title: 'Ik wil toch graag weten of ik misschien prostaatkanker heb.' },
            { title: 'Ik wil dan liever niet weten of ik misschien prostaatkanker heb.' },
          ],
        },
      ],
      button: 'Ga verder',
    },
    {
      path: '/stap-4/vraag-4',
      routeId: 'P2-021',
      nextRouteId: 'P2-022',
      type: 'question',
      subtitle: 'Vraag',
      title:
        'Als prostaatkanker ontdekt wordt, is niet altijd behandeling nodig. Je moet dan afwachten. Sommige mensen krijgen daar veel stress van.',
      questions: [
        {
          type: 'single',
          answers: [
            { title: 'Ik vind afwachten geen probleem.' },
            { title: 'Ik vind afwachten niet prettig.' },
          ],
        },
      ],
      button: 'Ga verder',
    },
    {
      path: '/stap-4/vraag-5',
      routeId: 'P2-022',
      nextRouteId: 'P2-023',
      type: 'question',
      subtitle: 'Vraag',
      title: 'Kies je voor een behandeling?',
      description: `
        <p>Soms is niet zeker of een behandeling voor prostaatkanker nodig is. Omdat niet zeker is of die wel helpt. Van een behandeling kun je wel klachten krijgen. Bijvoorbeeld moeilijk je plas ophouden.</p>
        <p>Kies je dan toch voor een behandeling?</p>
      `,
      descriptionAlign: 'left',
      questions: [
        {
          type: 'single',
          answers: [
            { title: 'Ja, ik kies dan toch voor een behandeling.' },
            { title: 'Nee, ik kies dan niet voor een behandeling.' },
          ],
        },
      ],
      button: 'Ga verder',
    },
    {
      path: '/print-overview',
      routeId: 'P2-023',
      nextRouteId: 'end',
      type: 'end',
      header: {
        subtitle: 'Einde keuzehulp',
        title: 'Hier zijn je antwoorden bij deze keuzehulp',
        description: `
          <div>
            <p>
              Hier zijn de antwoorden die je in deze keuzehulp gaf. Je kunt ze gebruiken in het gesprek met je arts.<br />
              Misschien denk je over een paar jaar nog een keer na over testen op prostaatkanker. Dan kun je de keuzehulp opnieuw invullen.
            </p>
          </div>
        `,
      },
    },
  ],
}

export default psa
